import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicLayout } from './layouts/PublicLayout';
import { PanelLayout } from './layouts/PanelLayout';
import { AdminLayout } from './layouts/AdminLayout';
import { RequireAuth } from './lib/auth';
import { HomePage } from './pages/Home';
import { PricingPage } from './pages/Pricing';
import { AboutPage, CancellationPage, ContactPage, CookiesPage, FaqPage, PrivacyPage, SupportPage, TermsPage } from './pages/Static';
import { SearchPage } from './pages/Search';
import { PublicProfilePage } from './pages/PublicProfile';
import { ConfirmationPage } from './pages/Confirmation';
import { LoginPage } from './pages/auth/Login';
import { SignupProfessionalPage } from './pages/auth/SignupProfessional';
import { ForgotPasswordPage } from './pages/auth/ForgotPassword';
import { ResetPasswordPage } from './pages/auth/ResetPassword';
import { PanelOverviewPage } from './pages/panel/Overview';
import { PanelAppointmentsPage } from './pages/panel/Appointments';
import { PanelServicesPage } from './pages/panel/Services';
import { PanelSchedulePage } from './pages/panel/Schedule';
import { PanelClientsPage } from './pages/panel/Clients';
import { PanelPublicProfilePage } from './pages/panel/PublicProfileSettings';
import { PanelReportsPage } from './pages/panel/Reports';
import { PanelPlanPage } from './pages/panel/Plan';
import { PanelSettingsPage } from './pages/panel/Settings';
import { PanelSupportPage } from './pages/panel/Support';
import { PanelOnboardingPage } from './pages/panel/Onboarding';
import { AdminOverviewPage } from './pages/admin/Overview';
import { AdminUsersPage } from './pages/admin/Users';
import { AdminBusinessesPage } from './pages/admin/Businesses';
import { AdminSubscriptionsPage } from './pages/admin/Subscriptions';
import { AdminActivationsPage } from './pages/admin/Activations';
import { AdminLicensesPage } from './pages/admin/Licenses';
import { AdminPlansPage } from './pages/admin/Plans';
import { AdminCategoriesPage } from './pages/admin/Categories';
import { AdminAuditPage } from './pages/admin/Audit';
import { AdminSettingsPage } from './pages/admin/Settings';
import { AdminReviewsPage } from './pages/admin/Reviews';
import { NotFoundPage } from './pages/NotFound';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicLayout>
            <HomePage />
          </PublicLayout>
        }
      />
      <Route path="/precos" element={<PublicLayout><PricingPage /></PublicLayout>} />
      <Route path="/busca" element={<PublicLayout><SearchPage /></PublicLayout>} />
      <Route path="/profissional/:slug" element={<PublicLayout><PublicProfilePage /></PublicLayout>} />
      <Route path="/agendamento/confirmado/:code" element={<PublicLayout><ConfirmationPage /></PublicLayout>} />
      <Route path="/sobre" element={<PublicLayout><AboutPage /></PublicLayout>} />
      <Route path="/contato" element={<PublicLayout><ContactPage /></PublicLayout>} />
      <Route path="/faq" element={<PublicLayout><FaqPage /></PublicLayout>} />
      <Route path="/suporte" element={<PublicLayout><SupportPage /></PublicLayout>} />
      <Route path="/termos" element={<PublicLayout><TermsPage /></PublicLayout>} />
      <Route path="/privacidade" element={<PublicLayout><PrivacyPage /></PublicLayout>} />
      <Route path="/cancelamento" element={<PublicLayout><CancellationPage /></PublicLayout>} />
      <Route path="/cookies" element={<PublicLayout><CookiesPage /></PublicLayout>} />
      <Route path="/entrar" element={<PublicLayout><LoginPage /></PublicLayout>} />
      <Route path="/comecar" element={<PublicLayout><SignupProfessionalPage /></PublicLayout>} />
      <Route path="/esqueci-senha" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />
      <Route path="/redefinir-senha" element={<PublicLayout><ResetPasswordPage /></PublicLayout>} />

      <Route
        path="/painel"
        element={
          <RequireAuth role="business">
            <PanelLayout>
              <PanelOverviewPage />
            </PanelLayout>
          </RequireAuth>
        }
      />
      <Route path="/painel/configurar" element={<RequireAuth role="business"><PanelLayout><PanelOnboardingPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/agenda" element={<RequireAuth role="business"><PanelLayout><PanelSchedulePage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/agendamentos" element={<RequireAuth role="business"><PanelLayout><PanelAppointmentsPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/servicos" element={<RequireAuth role="business"><PanelLayout><PanelServicesPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/clientes" element={<RequireAuth role="business"><PanelLayout><PanelClientsPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/perfil" element={<RequireAuth role="business"><PanelLayout><PanelPublicProfilePage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/relatorios" element={<RequireAuth role="business"><PanelLayout><PanelReportsPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/plano" element={<RequireAuth role="business"><PanelLayout><PanelPlanPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/configuracoes" element={<RequireAuth role="business"><PanelLayout><PanelSettingsPage /></PanelLayout></RequireAuth>} />
      <Route path="/painel/suporte" element={<RequireAuth role="business"><PanelLayout><PanelSupportPage /></PanelLayout></RequireAuth>} />

      <Route path="/gestao" element={<PublicLayout><LoginPage portal="admin" /></PublicLayout>} />
      <Route path="/admin/entrar" element={<Navigate to="/gestao" replace />} />
      <Route path="/admin" element={<RequireAuth role="admin"><AdminLayout><AdminOverviewPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/usuarios" element={<RequireAuth role="admin"><AdminLayout><AdminUsersPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/empresas" element={<RequireAuth role="admin"><AdminLayout><AdminBusinessesPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/assinaturas" element={<RequireAuth role="admin"><AdminLayout><AdminSubscriptionsPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/ativacoes" element={<RequireAuth role="admin"><AdminLayout><AdminActivationsPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/licencas" element={<RequireAuth role="admin"><AdminLayout><AdminLicensesPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/planos" element={<RequireAuth role="admin"><AdminLayout><AdminPlansPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/categorias" element={<RequireAuth role="admin"><AdminLayout><AdminCategoriesPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/auditoria" element={<RequireAuth role="admin"><AdminLayout><AdminAuditPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/configuracoes" element={<RequireAuth role="admin"><AdminLayout><AdminSettingsPage /></AdminLayout></RequireAuth>} />
      <Route path="/admin/avaliacoes" element={<RequireAuth role="admin"><AdminLayout><AdminReviewsPage /></AdminLayout></RequireAuth>} />

      <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
    </Routes>
  );
}
